import { render, staticRenderFns } from "./ReferralAutocompleteMultiple.vue?vue&type=template&id=13b4a63a"
import script from "./ReferralAutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./ReferralAutocompleteMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports